document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const header = document.querySelector("sticky-header");
    const facets = document.querySelector(".sticky--facets");
    const placeholder = document.createElement("div");
    placeholder.className = "sticky--facets-placeholder";
    facets.parentNode.insertBefore(placeholder, facets.nextSibling);

    let headerHeight = header ? header.offsetHeight : 0;
    const facetsOffset = facets.offsetTop;

    const onScroll = () => {
      const scrollPosition = window.scrollY;

      if (header) {
        if (scrollPosition + headerHeight >= facetsOffset) {
          facets.classList.add("sticky");
          facets.style.top = `${headerHeight}px`;
          placeholder.style.height = `${facets.offsetHeight}px`;
        } else {
          facets.classList.remove("sticky");
          facets.style.top = "";
          placeholder.style.height = "0";
        }
      } else if (scrollPosition >= facetsOffset) {
        facets.classList.add("sticky");
        facets.style.top = "0";
        placeholder.style.height = `${facets.offsetHeight}px`;
      } else {
        facets.classList.remove("sticky");
        facets.style.top = "";
        placeholder.style.height = "0";
      }
    };

    if (header) {
      const resizeObserver = new ResizeObserver(() => {
        headerHeight = header.offsetHeight;
        onScroll();
      });
      resizeObserver.observe(header);

      window.addEventListener("beforeunload", () => {
        resizeObserver.disconnect();
      });
    }

    window.addEventListener("scroll", onScroll);
  }, 1000);
});
